import { createContext, useContext, useState, ReactNode, useCallback } from "react";

interface EnquiryPopupContextType {
  isExternalOpen: boolean;
  prefilledDestination: string;
  openWithDestination: (destination: string) => void;
  closeExternal: () => void;
}

const EnquiryPopupContext = createContext<EnquiryPopupContextType | undefined>(undefined);

export const EnquiryPopupProvider = ({ children }: { children: ReactNode }) => {
  const [isExternalOpen, setIsExternalOpen] = useState(false);
  const [prefilledDestination, setPrefilledDestination] = useState("");

  const openWithDestination = useCallback((destination: string) => {
    setPrefilledDestination(destination);
    setIsExternalOpen(true);
  }, []);

  const closeExternal = useCallback(() => {
    setIsExternalOpen(false);
    setPrefilledDestination("");
  }, []);

  return (
    <EnquiryPopupContext.Provider value={{ isExternalOpen, prefilledDestination, openWithDestination, closeExternal }}>
      {children}
    </EnquiryPopupContext.Provider>
  );
};

export const useEnquiryPopup = () => {
  const context = useContext(EnquiryPopupContext);
  if (!context) {
    throw new Error("useEnquiryPopup must be used within EnquiryPopupProvider");
  }
  return context;
};
